import { render, staticRenderFns } from "./DiffTable.vue?vue&type=template&id=7599ae2a&scoped=true&"
import script from "./DiffTable.vue?vue&type=script&lang=ts&"
export * from "./DiffTable.vue?vue&type=script&lang=ts&"
import style0 from "./DiffTable.vue?vue&type=style&index=0&id=7599ae2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599ae2a",
  null
  
)

export default component.exports